import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';


import UpperMenu from '../components/upper_menu/upper_menu.component'
import SearchPanel from '../components/search_panel/search_panel.component';
import compose from '../utils/compose'
import {getToken,getSToken} from '../utils/token'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import ModalOrder from '../components/modal_order/modal_order'
import TitleListHotels from '../components/title_list_hotels/titleListHotels.component'
//import HotelsForOrderList from '../components/hotels_for_order/hotels_for_order_list.component'
import HotelsForOrderList from '../components/hotels_for_order2/hotels_for_order_list.component'
import ModalOrderConfirmation from '../components/modal_order/modal_order_confirmation'
import ModalPlaceOrderNotValid from '../components/modal_order/modal_place_order_not_valid'
import ModalPlaceOrderNotValid2 from '../components/modal_order/modal_place_order_not_valid2'
import ModalPlaceOrderNotValidChildren from '../components/modal_order/modal_place_order_not_valid_Children'
import ModalHotelDetails from '../components/hotels_list/modal_hotel_details.component'
import ModalPlaceOrderWithReplace from '../components/modal_order/modal_place_order_with_replace'
import LastChanceButtonLeft from '../components/last_chance_buttons/buttonLeft.component'
import LastChanceButtonRight from '../components/last_chance_buttons/buttonRight.component'

import Spinner from 'react-bootstrap/Spinner'
class HomePage extends Component {

  state = {
    loading:true,
    modalDisplay:false,
    modalOrderDisplay:false,
    modalOrderWithReplaceDisplay : false,
    searchTitle: 'הזדמנות אחרונה',
    modalOrderConfirmationDisplay:false,
    modalPlaceOrderNotValid: false,
    modalPlaceOrderNotValid2: false,
    modalPlaceOrderNotValidChildren : false,
    placeOrderData:{},
    placeOrderDataResult: {},
    makeOrderData:{},
    makeOrderDataResult : {},
    hotelsForOrderLastChance: [], 
    modalHotelDisplay:false,
    currentHotel:{},
    currentFacilities:{}
    //lastChanceShow: false
  }
    

  setModalClosed = () => {
    this.setState({ modalDisplay: false});
  }
  setModalOpened = () => {
    this.setState({ modalDisplay: true});
  }


  setModalOrderClosed = (placeOrderData) => {
    const { nofeshService } = this.props;
    const { personData }  = this.props;

    console.log('Home setModalOrderClosed',placeOrderData);
    nofeshService.placeOrderRemove(

      placeOrderData.hotelForOrder.AllocationId).then( res  => {      
      
      this.setState({ modalOrderDisplay: false});    
    }); 
  }



  setModalOrderOpened = () => {
    this.setState({ modalOrderDisplay: true});
  }


  setModalOrderWithReplaceOpened = () => {
    this.setState({ modalOrderWithReplaceDisplay: true});
  }

  setModalOrderWithReplaceClosed= () => {
    this.setState({ modalOrderWithReplaceDisplay: false});
  }

  changeSearchOrderPlaces = (obj) => {
    Object.assign(this.changeSearchOrderPlaces, obj);
  }        


  DisplayForOrderWithReplace  = (data) => {
    this.setState({ modalOrderWithReplaceDisplay: false});
    this.DisplayForOrder(data);
  }

  DisplayForOrder = (data) => {
    const { currentSearchObj }  = this.props;
    const { personData }  = this.props;
    const { nofeshService } = this.props;
    let placeOrderData = {};

    const {token} = getToken(); 


    placeOrderData.EmployeeCardNum= token;
    placeOrderData.EmployeeIdNum= personData.EmployeeIdNum;
    placeOrderData.hotelForOrder = data.hotelForOrder;
    placeOrderData.search_param_num_family_adulds = currentSearchObj.search_param_num_family_adulds;
    placeOrderData.search_param_num_family_children = currentSearchObj.search_param_num_family_children;
    placeOrderData.search_param_num_family_babies = currentSearchObj.search_param_num_family_babies;
    placeOrderData.searchFieldGuests_placeholder = currentSearchObj.searchFieldGuests_placeholder;
    placeOrderData.vacationSelectedCycleYear = currentSearchObj.vacationSelectedCycleYear;

    this.setState({placeOrderData: placeOrderData});
    this.setState({loading:true});  
    if( data.replaceOrder != undefined) {
      placeOrderData.replaceOrder = data.replaceOrder;
    }



    nofeshService.placeOrder(placeOrderData).then( res  => {    
      
      console.log('HomePage DisplayForOrder  nofeshService.placeOrder data', res.data);

      this.setState({placeOrderDataResult: res.data});
      this.setState({loading:false}); 
      if (this.state.placeOrderDataResult == 1) {
          this.setModalOrderOpened();
      } 

      if (this.state.placeOrderDataResult == 2) {
        this.setModalOrderWithReplaceOpened();
      } 

      if ( this.state.placeOrderDataResult == -1) {
        this.setState({ modalPlaceOrderNotValid: true});
      }

      if ( this.state.placeOrderDataResult == -2) {
        this.setState({ modalPlaceOrderNotValid2: true});
      }

      if ( this.state.placeOrderDataResult == -3) {
        this.setState({ modalPlaceOrderNotValid2: true});
      }    

      if ( this.state.placeOrderDataResult == -4) {
        this.setState({ modalPlaceOrderNotValidChildren: true});
      } 
    }); 
}




  doOrder = (data) => {
    const { personData }  = this.props;
    const { nofeshService } = this.props;
    const { currentSearchObj }  = this.props;
    const {token} = getToken(); 

    let makeOrderData = {};


    makeOrderData.EmployeeCardNum= token;
    makeOrderData.EmployeeIdNum= personData.EmployeeIdNum;
    makeOrderData.LastName= personData.last_name;
    makeOrderData.FirstName= personData.first_name;
    makeOrderData.hotelForOrder = data.hotelForOrder;
    makeOrderData.HasConnectionDoor = data.HasConnectionDoor;
    makeOrderData.IsCouplingRooms = data.IsCouplingRooms;

    makeOrderData.personsChildren = currentSearchObj.personsChildren;
    makeOrderData.EntitlementYear = currentSearchObj.vacationSelectedCycleYear;
    makeOrderData.search_param_num_family_adulds = data.search_param_num_family_adulds;
    makeOrderData.search_param_num_family_children = data.search_param_num_family_children;

    this.setState({loading:true});  
    this.setState({makeOrderData: makeOrderData}); 

    nofeshService.makeOrder(makeOrderData).then( res  => {      
      
      this.setState({makeOrderDataResult: res.data});
      if (this.state.makeOrderDataResult != 0) {
          this.setState({modalOrderConfirmationDisplay:true}); 
          this.setState({modalOrderDisplay:false}); 
          this.setState({loading:false}); 
          
      } else {
        this.setState({loading:false});
        this.setState({ redirect: "/emsg" }); 
      }

      //this.setState({loading:false});             
    }); 
}



setModalHotelDisplayClosed = () => {
  this.setState({ modalHotelDisplay: false});
}

setModalOrderConfirmationClosed = () =>  {
  this.setState({ modalOrderConfirmationDisplay: false});
}


setModalPlaceOrderNotValidClosed = () => {
  this.setState({ modalPlaceOrderNotValid: false});
}

setModalPlaceOrderNotValidClosed2 = () => {
  this.setState({ modalPlaceOrderNotValid2: false});
}

setModalPlaceOrderNotValidClosedChildren = () => {
  this.setState({ modalPlaceOrderNotValidChildren: false});
  this.props.setModalAfterLoggingClose();
}


DisplayForHotelDetails = (hotelId) => {
    this.setState({loading:true});  
    const { nofeshService } = this.props;

    nofeshService.getHotelDetails(hotelId).then( res  => {    
        console.log('HomePage DisplayForHotelDetails getHotelDetails res',res);

        this.setState({ currentHotel: res.data.hotel });
        this.setState({ currentFacilities: res.data.facilities });
        this.setState({ modalHotelDisplay: true });
        this.setState({loading:false});             
    }); 
}




  componentDidMount = () => {

  }



  onLoggedOutRefresh = () => {

    console.log('HomePage onLoggedOutRefresh props ', this.props);
    this.props.onLoggedOutRefresh();
  }



  setCurrentHotelsForOrderLastChance = (lastChanceType) => {

    console.log('HomePage setCurrentHotelsForOrderLastChance lastChanceType', lastChanceType);

    let data = this.props.currentSearchObj;
    data.lastChanceType = lastChanceType;
   
    if (lastChanceType == 0){
      this.setState({searchTitle:"הזדמנות אחרונה"});
    } else if (lastChanceType == 1){
      this.setState({searchTitle:"הזדמנות אחרונה - אילת"});   
    } else if (lastChanceType == 2) {
      this.setState({searchTitle:"הזדמנות אחרונה - כל הארץ למעט אילת"});   
    }
    this.props.setCurrentHotelsForOrderLastChanceHomePage(data);

    window.scrollTo({
      top: 100,
      behavior: "smooth"
      });
  }


  render() {         

    let noEntitlementsAlailiable = false;
    if ( this.props.personData.hasEntitlementsNotOrdered == 0 && 
         this.props.personData.hasEntitlementsOrderedNotRealized == 0) 
         {
            noEntitlementsAlailiable = true;
         }

    let lastChanceShow = false;
    if (this.props.currentSearchObj.lastChanceType) {
      if (this.props.currentSearchObj.lastChanceType == 1 || this.props.currentSearchObj.lastChanceType == 2){
        lastChanceShow = true;
      }
    }

    return (      
        <React.Fragment>                                 
            <div className="hp_banner">

            {(this.props.loading ) ? 
              <div className="cntered-flex directionRtl">טוען נתונים ...</div>
              :
              <React.Fragment>
                <UpperMenu  
                    personData={this.props.personData} 
                    onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                />
                {(this.props.personData.vacationCyclesYears ) ?
                  <SearchPanel  
                    personData={this.props.personData} 
                    setCurrentAppData={this.props.setCurrentAppData} 
                    currentSearchObj={this.props.currentSearchObj}
                  />
                : null }
              </React.Fragment>}

            </div>

            {(!this.props.loading ) ? 
            <React.Fragment>

              
            {(this.state.modalOrderDisplay) ?    
                <ModalOrder  
                  personData={this.props.personData} 
                  setModalOrderClosed={this.setModalOrderClosed}
                  placeOrderData={this.state.placeOrderData}
                  doOrder={this.doOrder}
                  />
              : null}

                {(this.state.modalOrderConfirmationDisplay) ?    
                  <ModalOrderConfirmation  
                      makeOrderData={this.state.makeOrderData}
                      orderId={this.state.makeOrderDataResult}
                      makeOrderDataResult={this.state.makeOrderDataResult}
                      setModalOrderConfirmationClosed={this.setModalOrderConfirmationClosed}
                    />
                  : null} 


                
                {(this.state.modalPlaceOrderNotValid) ?    
                  <ModalPlaceOrderNotValid 
                      placeOrderData={this.state.placeOrderData}
                      setModalPlaceOrderNotValidClosed={this.setModalPlaceOrderNotValidClosed}
                    />
                  : null} 



                {(this.state.modalPlaceOrderNotValid2) ?    
                  <ModalPlaceOrderNotValid2
                      placeOrderData={this.state.placeOrderData}
                      setModalPlaceOrderNotValidClosed2={this.setModalPlaceOrderNotValidClosed2}
                    />
                  : null} 



                {(this.props.showModalFirst) ?    
                  <ModalPlaceOrderNotValidChildren

                      setModalPlaceOrderNotValidClosedChildren={this.setModalPlaceOrderNotValidClosedChildren}
                      modalFirstMsg={this.props.modalFirstMsg}
                    />
                  : null} 



                {(this.state.modalOrderWithReplaceDisplay) ?    
                  <ModalPlaceOrderWithReplace
                      placeOrderData={this.state.placeOrderData}
                      setModalOrderWithReplaceClosed={this.setModalOrderWithReplaceClosed}
                      DisplayForOrderWithReplace={this.DisplayForOrderWithReplace}
                    />
                  : null} 



                {(this.state.modalHotelDisplay && this.state.currentHotel) ?     
                      <ModalHotelDetails 
                          hotel={this.state.currentHotel}
                          facilities={this.state.currentFacilities}
                          setModalHotelDisplayClosed={this.setModalHotelDisplayClosed} >
                      </ModalHotelDetails>
                    :null}                 
    
              <div className="hp_container">       
                 
                    <div className="hp_section_container">
                        <TitleListHotels titleListHotels={this.state.searchTitle} />

                        {(this.props.loadingLastChance) ?   
                        <div className="cntered-flex directionRtl"> מעדכן נתוני הזדמנות אחרונה  ...</div>
                        : null}

                        {(!noEntitlementsAlailiable && !lastChanceShow  && !this.props.loadingLastChance ) ?

                            <div className="cntered-flex padding_bottom_500">
                              <div className="hp_last_chance_button_container">
                                <LastChanceButtonLeft
                                    setCurrentHotelsForOrderLastChance={this.setCurrentHotelsForOrderLastChance} >
                                </LastChanceButtonLeft>


                                <LastChanceButtonRight
                                    setCurrentHotelsForOrderLastChance={this.setCurrentHotelsForOrderLastChance} >
                                </LastChanceButtonRight>

                                </div>
                            </div>
                        : null}




                        {(lastChanceShow &&  !this.props.loadingLastChance) ? 
                        <HotelsForOrderList  
                            hotelsForOrder={this.props.hotelsForOrderLastChance}  
                            DisplayForOrder={this.DisplayForOrder}
                            DisplayForHotelDetails={this.DisplayForHotelDetails}  
                          />
                        :null }  



                        {(lastChanceShow  && !this.props.loadingLastChance ) ? 
                        <div className="cntered-flex">

                          { (this.props.currentSearchObj.lastChanceType == 1 ) ?
                            <div className="last_chance_inner_button_ok2"
                                  onClick={() => this.setCurrentHotelsForOrderLastChance(2)}>
                                  <div className="title">הזדמנות אחרונה כל היעדים</div>
                            </div>
                              :
                            <div className="last_chance_inner_button_ok2"
                                  onClick={() => this.setCurrentHotelsForOrderLastChance(1)}>
                                  <div className="title">הזדמנות אחרונה באילת</div>
                            </div>
                          }

                        </div>
                        : null}
                    </div>  
                   
              </div>
            </React.Fragment>
            : null}

            <div className="hp_footer">
            </div>
        </React.Fragment>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(HomePage);



